module.exports = __webpack_public_path__ + "static/bulkProductUploadImage-b586b860b66134f1db99b00269c2f59b.png";